module.exports = __webpack_public_path__ + "static/media/appstore.c6a48690.png";